import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Typography, Grid, TextField, Container, MenuItem, Button } from '@mui/material';
import { isMobileSize } from '../../helpers/functions/functions';
import { ReactComponent as BankIDLogo } from '../../assets/icons/BankID_logo.svg';

import {
	loginBankIDAction,
	checkBankIdProgress,
	bankIDQRGeneratorAction,
	resetBankIDProgress,
	loginAutostartBankIDAction,
	createSessionAction,
} from './actions/loginActions';

import { Refresh as RefreshIcon } from '@mui/icons-material';

import BankIDlogo from '../../assets/images/bankid.png';

class LoginBankID extends Component {
	constructor(props) {
		super(props);

		this.state = {
			session_id: null,
			status: 'pending',
			QRImage: null,
			autoStartUrl: null,
		};

		this.pollSession = null;
	}
	componentDidMount() {
		this.props.resetBankIDProgress();

		this.createSessionAction();
	}

	createSessionAction = () => {
		this.props.createSessionAction({
			language: this.state.selectedLanguage,
			client_id: this.props.client ? this.props.client.id : null,
			callback: (data) => {
				this.setState({
					QRImage: 'data:image/svg+xml;base64,' + data.QRCode,
					autoStartUrl: 'https://app.bankid.com/?autostarttoken=' + data.autoStartToken + '&redirect=',
					session_id: data.sessionId,
					status: data.status,
				});

				this.pollSession = setInterval(() => {
					if (data.sessionId) {
						this.props.checkBankIdProgress(
							(data) => {
								if (data.token_invite && data.status === 'confirmed') {
									if (this.props.callback) {
										this.props.callback();
									}
								} else {
									if (data.status === 'failed') {
										clearInterval(this.pollSession);
										this.setState({ QRImage: null, status: 'failed', autoStartUrl: null });
									} else {
										this.setState({
											QRImage: 'data:image/svg+xml;base64,' + data.QRCode,
											autoStartUrl: 'https://app.bankid.com/?autostarttoken=' + data.autoStartToken + '&redirect=',
											session_id: data.sessionId,
											status: data.status,
										});
									}
								}
							},
							this.props.type === 'login_meeting'
								? { user_type: 'meeting_access', meeting_token: this.props.meeting_token }
								: this.props.token_invite && { token_invite: this.props.token_invite }
						);
					} else {
						clearInterval(this.pollSession);
					}
				}, 3000);
			},
		});
	};

	componentWillUnmount() {
		clearInterval(this.pollSession);
		this.props.resetBankIDProgress();
	}

	state = {
		ssn: '',
		selectedLanguage: this.props.selectedLanguage,
		refreshQrcodeError: false,
	};

	render() {
		const { translate } = this.props;

		return (
			<React.Fragment>
				<Grid container spacing={1} direction="column" alignItems="center" justifyContent="center">
					<Grid item xs={12} md={12}>
						<Typography variant="body2" component="p" gutterBottom fontWeight="bold">
							{translate(this.props.token_invite ? 'register_invite_bank_id_title' : 'bank_id_title')}
						</Typography>
					</Grid>
					<input id="deviceid" name="deviceid" type="hidden" />
					{!isMobileSize() && (
						<Grid item xs={12} md={12}>
							{this.state.QRImage !== null ? (
								<img className="generic-square-edges-image" src={this.state.QRImage} />
							) : (
								<img src={BankIDlogo} height="70" alt="BankID logo" />
							)}
						</Grid>
					)}
					{!isMobileSize() && this.state.status === 'failed' && (
						<Grid item xs={12} md={12}>
							<Button
								color="primary"
								variant="contained"
								size="small"
								className="login-bankid-button-refresh"
								onClick={(e) => {
									this.createSessionAction();
								}}
								sx={{ textTransform: 'none' }}
							>
								{translate('login_bankid_button_refresh')}
								<RefreshIcon />
							</Button>
						</Grid>
					)}
					<Grid item xs={12} md={12}>
						<Typography variant="body2" component="p" gutterBottom>
							{translate(this.props.token_invite ? 'register_invite_user_register_banck_id_info' : 'user_register_banck_id_info')}
						</Typography>
					</Grid>
					{this.state.autoStartUrl && (
						<Grid item xs={12} md={12}>
							<Button
								variant="contained"
								color={'primary'}
								href={this.state.autoStartUrl}
								startIcon={<BankIDLogo style={{ width: 30, height: 30 }} />}
								sx={{ textTransform: 'none' }}
							>
								{translate('login_bankid_start_app_button')}
							</Button>
						</Grid>
					)}
				</Grid>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	bankid_progress: state.login.bankid_progress,
	autostarttoken: state.login.autostarttoken,
	login: state.login,
	translate: getTranslate(state.localize),
	settings: state.settings,
	client: state.login.client,
});

export default connect(mapStateToProps, {
	loginBankIDAction,
	checkBankIdProgress,
	bankIDQRGeneratorAction,
	resetBankIDProgress,
	loginAutostartBankIDAction,
	createSessionAction,
})(LoginBankID);
